module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i-box', {
    staticClass: "dashboard-unit",
    style: ({
      height: _vm.height
    })
  }, [_c('span', {
    staticClass: "unit-title",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('span', {
    class: _vm.titleIconClass
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('el-tooltip', {
    attrs: {
      "content": _vm.titleRightIcon.tooltip,
      "placement": "top"
    }
  }, [_c('span', {
    class: _vm.titleRightIcon.icon,
    on: {
      "click": _vm.rightIconClick
    }
  })])], 1)]), _vm._v(" "), _c('span', {
    staticClass: "unit-content",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._t("unit-content")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5df38bd8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/programmingDashboard/ProgrammingDashboardUnit.vue
// module id = 3300
// module chunks = 3